<template>
  <div class="content-custom bg-image text-white">
    <div class="mx-auto divContactoContenedor">
      <div class="col-12 row justify-content-between divContactoLogos">
        <div class="w-fc" @click="() => $router.push('/')">
          <img src="../../public/assets/images/logos/LogoFriaxBlanco.svg" class="logoContactoFriax" alt="">
        </div>
        <div class="w-fc" @click="() => $router.push('/terranova')">
          <img src="../../public/assets/images/terranova/terranovaBanner.png" class="logoContactoTerranova">
        </div>
      </div>
      <div class="col-12 row justify-content-between">
        <div class="divContactoForm">

          <p class="titulo">Contáctanos</p>
          <div class="w-full d-grid gap25 mb30">
            <input type="text" v-model="nombre" class="form-control" id="nombreCompleto" placeholder="Nombre Completo">
            <input type="text" v-model="telefono" class="form-control" id="telefono" placeholder="Teléfono">
            <input type="email" v-model="correo" class="form-control" id="email" placeholder="Email">
            <textarea class="form-control" v-model="message" id="mensaje" rows="3"
              placeholder="Déjanos un mensaje"></textarea>
          </div>
          <div class=" col-12 text-center mb25">
            <button type="button" class="btn btn-primary4 btn-rounded mx-auto" @click="sendForm">Enviar<i
                class="fa fa-paper-plane mx-2"></i></button>
          </div>
          <p class="extra">Tu información personal es estrictamente confidencial y no será
            compartida
            con ninguna organización externa. Al enviar este formulario con tu información, das tu consentimiento para
            que Friax Construcciones y sus representantes autorizados te contacten.</p>
        </div>
        <div class="divContactoMapa ml-auto mb-4 d-flex justicy-content-center">
          <Mapa class="divContactoMapa mx-auto" />
        </div>
      </div>
    </div>
    <!-- Toast -->
    <div class="toast-container position-fixed text-dark top-0 end-0 p-3">
      <div class="toast" id="feedbackToast" ref="feedbackToast" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header">
          <strong class="me-auto">{{ toastTitle }}</strong>
          <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body" v-html="toastMessage">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mapa from '../components/Mapa.vue';
import { useEmail } from '../components/logicas/useEmail';
import { data } from '../data/configApp';

export default {
  name: 'Contacto',
  components: {
    Mapa
  },
  setup() {
    const { handleSendMail, toastTitle, toastMessage, showToast, closeToast } = useEmail();

    return {
      handleSendMail,
      toastTitle,
      toastMessage,
      showToast,
      closeToast
    };
  },
  data() {
    return {
      nombre: null,
      telefono: null,
      correo: null,
      message: null
    };
  },
  methods: {
    validateForm() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phonePattern = /^[0-9]{10}$/;
      let errors = [];

      if (!this.nombre) {
        errors.push('El nombre es obligatorio.');
      }
      if (!this.telefono || !phonePattern.test(this.telefono)) {
        errors.push('Por favor, ingresa un número de teléfono válido.');
      }
      if (!this.correo || !emailPattern.test(this.correo)) {
        errors.push('Por favor, ingresa un correo electrónico válido.');
      }
      if (!this.message) {
        errors.push('El mensaje es obligatorio.');
      }

      if (errors.length > 0) {
        this.showToast('Error', errors.join('<br>'));
        return false;
      }
      return true;
    },
    async sendForm() {
      if (this.validateForm()) {
        console.log('Formulario enviado');
        await this.handleSendMail(data.mailFriax, "Informes sobre FRIAX - Contacto", `Nombre: ${this.nombre}\nTeléfono: ${this.telefono}\nMensaje: ${this.message}`);
      }
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url("../../public/assets/images/contacto/Friax_BannerContacto.png");
  /* Cambia esta ruta a la de tu imagen */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>